import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { IProps } from './types';
import { IPaymentState, IPaymentFormValue } from 'constants/models/components/insureProcessCar/payment';
import service from 'bff/services/carProductService';
import _ from 'lodash';
import { Code, SysOption } from 'bff/models/info';
import { PaymentMethod } from 'constants/enums/paymentMethod.enum';
import sweetAlertService from 'utils/sweetAlertService';
import { PaymentContent, BankContent } from 'bff/models/product/paymentMethod';
import { ApplyType } from 'constants/enums/applyType.enum';
import InputWithRegex from 'components/InputWithRegex';
import moment from 'moment';
import { NationalType } from 'constants/enums/nationalType.enum';
import { PaymentNccReq, PaymentEBillReq } from 'bff/models/product';
import memberProfileService from 'bff/services/memberProfileService';
import commonService from 'utils/commonService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { InsuredRoleType } from 'constants/enums/insuredRoleType.enum';
import { InsuredRelation } from 'constants/enums/insuredRelation.enum';
import { CodeId } from 'constants/enums/codeId.enum';
import { PayerContent } from 'bff/models/member/boPayby';
import { RuleCheckInsuredType } from 'constants/enums/ruleCheckInsuredType.enum';
import { PolicyItemListContent } from 'bff/models/product/vehicleItemList';
import { VehicleItemType } from 'constants/enums/vehicleItemType';
import apiCommonService from 'bff/services/commonService';

const initFormVal: IPaymentFormValue = {
  PAYMENT_METHOD: PaymentMethod.CreditCard,
  RECEIVE_INFO: '',
  CREDIT_ACCOUNT_HOLDER_NAME: '',
  CREDIT_ACCOUNT_HOLDER_ID: '',
  CREDIT_ACCOUNT_HOLDER_ID_ERROR: true,
  CREDIT_ACCOUNT_HOLDER_RELATION: '',
  CREDIT_PAYER_ID: '',
  CREDIT_PAYER_TYPE: InsuredRoleType.Application,
  PAN1st: '',
  PAN2nd: '',
  PAN3rd: '',
  PAN4th: '',
  CARD_VERIFY_CODE: '',
  EXPIREDATE_MONTH: '',
  EXPIREDATE_YEAR: '',
  BANK_CODE: '',
  BANK_ACCOUNT: '',
  BANK_ACCOUNT_HOLDER_ID: '',
  BANK_ACCOUNT_HOLDER_ID_ERROR: true,
  BANK_ACCOUNT_HOLDER_NAME: '',
  BANK_ACCOUNT_HOLDER_RELATION: '',
  BANK_PAYER_ID: '',
  BANK_PAYER_TYPE: InsuredRoleType.Application
};

let formInitialValues: IPaymentFormValue = initFormVal;

class InsureProcessPayment extends React.Component<IProps, IPaymentState> {
  private formikRef: any = React.createRef();

  state: IPaymentState = {
    activePaymentMethod: PaymentMethod.CreditCard,
    agreeContract: false,
    activeInsRoleType: InsuredRoleType.Application,
    paymentMethod: {
      PAYMENT_INFO: {
        COMMON_MSG: {
          BANKACCOUNT: {
            BANK: new Array(0),
            NOTICE_B: '',
            NOTICE_C: ''
          },
          CLAIMS: {
            HEAD: '',
            BODY: '',
            ANSWER: {
              HEAD: '',
              BODY: ''
            }
          },
          CREDITCARD: {
            BANK: new Array(0),
            NOTICE_B: '',
            NOTICE_C: ''
          }
        },
        LEGAL_RELATION: new Array(0),
        PAYMENT_OPTION: [{}]
      }
    },
    insRoleTypeSysOpts: new Array(0),
    onlyApplicant: false,
    onlyInsured: false,
    isSelf: false,
    showCreditCard: true,
    showBarCode: false,
    barcodeNoteCodes: new Array(0),
    barcodeNoticeCodes: new Array(0)
  }

  componentDidMount = async () => {
    commonService.scrollToTop();

    let activePaymentMethod = PaymentMethod.CreditCard;
    let activeInsRoleType = InsuredRoleType.Application;
    let onlyApplicant: any;
    let onlyInsured: any;
    let isSelf: any;
    let showCreditCard: any;
    let applyNo: any;
    let showBarcode = false;

    if (this.props.boPayby.APPLY_NO) {
      applyNo = this.props.boPayby.APPLY_NO;

      const policyholders =
        _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Applicant);

      formInitialValues = {
        ...formInitialValues,
        BANK_PAYER_TYPE: InsuredRoleType.Application,
        BANK_PAYER_ID: policyholders[0].ID,
        CREDIT_PAYER_TYPE: InsuredRoleType.Application,
        CREDIT_PAYER_ID: policyholders[0].ID
      };

      const insureds =
        _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

      // 自然人-同被保人狀態
      isSelf = policyholders[0].ID === insureds[0].ID &&
        policyholders[0].ID_TYPE !== NationalType.Legal &&
        insureds[0].ID_TYPE !== NationalType.Legal;

      // 僅要保人可以使用信用卡付費
      onlyApplicant = insureds[0].ID_TYPE === NationalType.Legal &&
        policyholders[0].ID_TYPE !== NationalType.Legal;

      // 僅被保人可以使用信用卡付費
      onlyInsured = insureds[0].ID_TYPE !== NationalType.Legal &&
        policyholders[0].ID_TYPE === NationalType.Legal;

      if (!isSelf && onlyInsured) {
        activeInsRoleType = InsuredRoleType.Insured;
        formInitialValues = {
          ...formInitialValues,
          CREDIT_PAYER_TYPE: InsuredRoleType.Insured,
          CREDIT_PAYER_ID: insureds[0].ID
        };
      }

      // 判斷是否顯示信用卡付款
      showCreditCard = insureds[0].ID_TYPE !== NationalType.Legal ||
        policyholders[0].ID_TYPE !== NationalType.Legal;

      if (!showCreditCard) {
        activePaymentMethod = PaymentMethod.BankAccount;
        formInitialValues = {
          ...formInitialValues,
          PAYMENT_METHOD: PaymentMethod.BankAccount
        };
      }

      // 判斷是否顯示 Barcode
      showBarcode = await this.handleValidateShowBarCode(
        this.props.boPayby.CO_START_DATE,
        this.props.boPayby.VO_START_DATE,
        this.props.boPayby.BC_TYPE);
    } else {
      const { tempSelectFormValue } = this.props.tempSelect;
      const { tempFillState, tempFillFormValue } = this.props.tempFill;
      if (!tempFillState || !tempFillFormValue || !tempSelectFormValue) return;

      applyNo = tempFillState.serialNo as string;

      formInitialValues = {
        ...formInitialValues,
        BANK_PAYER_TYPE: InsuredRoleType.Application,
        BANK_PAYER_ID: tempFillFormValue.POLICYHOLDER_MEMBER_ID,
        CREDIT_PAYER_TYPE: InsuredRoleType.Application,
        CREDIT_PAYER_ID: tempFillFormValue.POLICYHOLDER_MEMBER_ID
      };

      // 自然人-同被保人狀態
      isSelf = tempFillFormValue.POLICYHOLDER_NATIONALITY_TYPE !== NationalType.Legal &&
        tempFillFormValue.POLICYHOLDER_RELATION === InsuredRelation.SameInsured;

      // 僅要保人可以使用信用卡付費
      onlyApplicant = tempFillFormValue.INSURED_NATIONALITY_TYPE === NationalType.Legal &&
        tempFillFormValue.POLICYHOLDER_NATIONALITY_TYPE !== NationalType.Legal;

      // 僅被保人可以使用信用卡付費
      onlyInsured = tempFillFormValue.INSURED_NATIONALITY_TYPE !== NationalType.Legal &&
        tempFillFormValue.POLICYHOLDER_NATIONALITY_TYPE === NationalType.Legal;

      if (!isSelf && onlyInsured) {
        activeInsRoleType = InsuredRoleType.Insured;
        formInitialValues = {
          ...formInitialValues,
          CREDIT_PAYER_TYPE: InsuredRoleType.Insured,
          CREDIT_PAYER_ID: tempFillFormValue.INSURED_MEMBER_ID
        };
      }

      // 判斷是否顯示信用卡付款
      showCreditCard = tempFillFormValue.INSURED_NATIONALITY_TYPE !== NationalType.Legal ||
        tempFillFormValue.POLICYHOLDER_NATIONALITY_TYPE !== NationalType.Legal;

      if (!showCreditCard) {
        activePaymentMethod = PaymentMethod.BankAccount;
        formInitialValues = {
          ...formInitialValues,
          PAYMENT_METHOD: PaymentMethod.BankAccount
        };
      }

      // 取得有投保項目
      const insuredPolicys = this.handleFetchInsuredPolicys(tempSelectFormValue.POLICY_ITEM);

      // 判斷是否顯示 Barcode
      showBarcode = await this.handleValidateShowBarCode(
        tempSelectFormValue.COMPULSORY_INS_EFFECTIVE_DATE,
        tempSelectFormValue.ARBITRARY_INS_EFFECTIVE_DATE,
        tempFillState.applyType,
        insuredPolicys);
    }

    const initSetting = await service.fetchInitPayment(applyNo, this.props.insTypeId);

    if (Object.keys(initSetting.paymentMethod).length === 0) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '無法取得付款方式'
      });

      return;
    }

    this.setState({
      activePaymentMethod: activePaymentMethod,
      activeInsRoleType: activeInsRoleType,
      paymentMethod: { ...initSetting.paymentMethod },
      insRoleTypeSysOpts: [...initSetting.insRoleTypeSysOpts],
      onlyApplicant: onlyApplicant,
      onlyInsured: onlyInsured,
      isSelf: isSelf,
      showCreditCard: showCreditCard,
      showBarCode: showBarcode,
      barcodeNoteCodes: [...initSetting.barcodeNoteCodes],
      barcodeNoticeCodes: [...initSetting.barcodeNoticeCodes]
    });

    // console.log('temp state', JSON.stringify(this.props.tempState));
  }

  componentDidUpdate () {
    // console.log('InsureProcessPayment componentDidUpdate', this.state);
  }

  componentWillUnmount () {
    if (!this.formikRef || !this.formikRef.current) return;

    const formVal = this.formikRef.current.values;
    this.props.onUnmount(formVal, this.state);

    formInitialValues = {
      ...initFormVal
    };
  }

  /**
   * @description 取得有投保的保障內容資料
  */
  handleFetchInsuredPolicys = (policyItemList: PolicyItemListContent[]) => {
    const insuredPolicy = new Array(0);

    _.forEach(policyItemList, (policyItem: PolicyItemListContent) => {
      _.forEach(policyItem.MAIN_ITEMS, (mainItem: any) => {
        if (mainItem.CHECKED) {
          insuredPolicy.push({
            ...mainItem,
            ITEM: mainItem,
            ITEM_TYPE: policyItem.ITEM_TYPE
          });
        }

        if (mainItem.ADDITIONAL_TERM && mainItem.ADDITIONAL_TERM.length > 0) {
          _.forEach(mainItem.ADDITIONAL_TERM, (additionalTerm: any) => {
            if (additionalTerm.CHECKED) {
              insuredPolicy.push({
                ...additionalTerm,
                ITEM: additionalTerm,
                ITEM_TYPE: policyItem.ITEM_TYPE
              });
            }
          });
        }
      });

      _.forEach(policyItem.SUB_ITEMS, (subItem: any) => {
        if (subItem.CHECKED) {
          insuredPolicy.push({
            ...subItem,
            ITEM: subItem,
            ITEM_TYPE: policyItem.ITEM_TYPE
          });
        }

        if (subItem.ADDITIONAL_TERM && subItem.ADDITIONAL_TERM.length > 0) {
          _.forEach(subItem.ADDITIONAL_TERM, (additionalTerm: any) => {
            if (additionalTerm.CHECKED) {
              insuredPolicy.push({
                ...additionalTerm,
                ITEM: additionalTerm,
                ITEM_TYPE: policyItem.ITEM_TYPE
              });
            }
          });
        }
      });
    });

    return insuredPolicy;
  }

  /**
   * @description 判斷是否顯示 Barcode 付費
   */
  handleValidateShowBarCode = async (compulsoryDate: any, arbitraryDate: any, applyType: string, insuredPolicys?: any) => {
    if (applyType !== ApplyType.WebRequire) return false;
    let hasCompulsory = moment(compulsoryDate).isValid();
    let hasArbitrary = moment(arbitraryDate).isValid();

    if (insuredPolicys) {
      // 是否包含強制險項目
      hasCompulsory = this.handleValidateHasType(insuredPolicys, VehicleItemType.CV_TYPE_CI);
      // 是否包含任意險項目
      hasArbitrary = this.handleValidateHasType(insuredPolicys, VehicleItemType.CV_TYPE_VI);
    }

    const serverTimeMs = await apiCommonService.fetchSysTime();
    const validDate = moment(serverTimeMs).add(7, 'd');

    const useDate = this.handleGetInsuredDate(hasCompulsory, hasArbitrary, compulsoryDate, arbitraryDate);
    if (moment(useDate).isValid()) {
      return moment(useDate).isAfter(validDate);
    }

    return false;
  }

  /**
   * @description 判斷是否包含判斷型態的投保項目
   */
  handleValidateHasType = (insuredPolicys: any, targetType: string) => {
    return _.findIndex(insuredPolicys, (insuredPolicy: any) =>
      insuredPolicy.CV_TYPE === targetType) !== -1;
  }

  /**
   * @description 取得要檢核用的生效日
   */
  handleGetInsuredDate = (hasCompulsory: boolean, hasArbitrary: boolean, compulsoryDate: any, arbitraryDate: any) => {
    const isCompulsoryDateValid = moment(compulsoryDate).isValid();
    const isArbitraryDateValid = moment(arbitraryDate).isValid();

    // 單獨強制險，判斷強制險預定生效日是否大於系統日 7 天後
    if (hasCompulsory && !hasArbitrary && isCompulsoryDateValid) {
      return moment(compulsoryDate);
    }

    // 單獨任意險，判斷任意險預定生效日是否大於系統日 7 天後
    if (!hasCompulsory && hasArbitrary && isArbitraryDateValid) {
      return moment(arbitraryDate);
    }

    // 強加任
    if (hasCompulsory && hasArbitrary && isCompulsoryDateValid && isArbitraryDateValid) {
      // 取 2 生效日最近的那個日期來比較
      const useDate = moment(compulsoryDate).isAfter(arbitraryDate)
        ? arbitraryDate
        : compulsoryDate;

      return moment(useDate);
    }
  }

  /**
   * @description 檢核帳號是否已存在格式是否正確
   */
  handleValidID = async (val: any, setFieldValue: any, errorName: string, memberIdError: boolean) => {
    if (val.length === 10 && memberIdError) {
      const errorVal = await memberProfileService.validMemberId(val).then((res: any) => res.ID);

      if (!errorVal) {
        setFieldValue(errorName, false);
      }

      return errorVal;
    }
  };

  /**
   * @description 表單 Submit 事件
  */
  handleFormSubmit = async (values: IPaymentFormValue) => {
    const btnPay = document.getElementById('btn_pay') as HTMLButtonElement;
    if (!btnPay) return;

    btnPay.disabled = true;

    if (values.PAYMENT_METHOD !== PaymentMethod.BarCode) {
      let fee;
      let applyNo;
      if (this.props.boPayby.APPLY_NO) {
        fee = `${this.props.boPayby.POLICY_FEE}`;
        applyNo = this.props.boPayby.APPLY_NO;
      } else {
        fee = `${commonService.getVehiclePrenium(this.props.tempSelect.tempSelectState?.evalCarRes.SUMPREMIUM[1].SUMPREMIUM, this.props.tempSelect.tempSelectState?.evalCarRes.SUMPREMIUM[1].SUMPREMIUMCI)}`;
        applyNo = this.props.tempFill.tempFillState?.serialNo as string;
      }

      // 執行線上付款-信用卡
      if (this.state.activePaymentMethod === PaymentMethod.CreditCard) {
        const paymentNccReq: PaymentNccReq = {
          APPLY_NO: applyNo,
          PAN: `${values.PAN1st}${values.PAN2nd}${values.PAN3rd}${values.PAN4th}`,
          EXPIREDATE: `${values.EXPIREDATE_MONTH}${values.EXPIREDATE_YEAR}`,
          TRANSAMT: fee || '',
          IDNUMBER: values.CREDIT_PAYER_ID,
          PAYER_NAME: this.handleGetPayerName(values.CREDIT_PAYER_TYPE, values.CREDIT_PAYER_ID),
          BC_TYPE: this.props.tempFill.tempFillState?.applyType
        };
        // console.log('paymentNccReq', JSON.stringify(paymentNccReq));
        const res = await service.paymentNccc(paymentNccReq);
        if (!res) {
          btnPay.disabled = false;
          return;
        };
      }

      // 執行線上付款-活期帳戶
      if (this.state.activePaymentMethod === PaymentMethod.BankAccount) {
        const paymentEBillReq: PaymentEBillReq = {
          personId: values.BANK_PAYER_ID,
          trnsOutBank: values.BANK_CODE,
          trnsOutAcct: values.BANK_ACCOUNT,
          // 總比數固定帶 1
          totalCount: '1',
          totalAmount: fee || '',
          APPLY_NO: applyNo,
          PAYER_NAME: this.handleGetPayerName(values.BANK_PAYER_TYPE, values.BANK_PAYER_ID)
        };
        // console.log('paymentEBillReq', JSON.stringify(paymentEBillReq));
        const res = await service.paymentEBill(paymentEBillReq);
        if (!res) {
          btnPay.disabled = false;
          return;
        };
      }
    }

    this.props.onPaymentSubmit(values, this.state);
    btnPay.disabled = false;
  }

  /**
   * @description 取得付款人姓名
  */
  handleGetPayerName = (payerType: string, payerId: string) => {
    if (this.props.boPayby.APPLY_NO) {
      return _.find(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.ID === payerId)?.NAME || '';
    }

    if (payerType === InsuredRoleType.Application) {
      return this.props.tempFill.tempFillFormValue?.POLICYHOLDER_NAME || '';
    }

    return this.props.tempFill.tempFillFormValue?.INSURED_NAME || '';
  }

  /**
   * 付款方式點選事件
   */
  handlePaymentMethodClick = (val: string) => {
    if (this.state.activePaymentMethod === val || !this.formikRef || !this.formikRef.current) return;

    let creditPayerType = InsuredRoleType.Application;
    let bankPayerType = InsuredRoleType.Application;
    let bankPayerId = '';
    let creditPayerId = '';
    let activeInsRoleType = InsuredRoleType.Application;

    if (this.props.boPayby.APPLY_NO) {
      const policyholders =
        _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Applicant);

      const insureds =
        _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

      if (insureds[0].ID_TYPE === NationalType.Legal) {
        this.setState({ activePaymentMethod: val, activeInsRoleType: activeInsRoleType });
        return;
      }

      // 要、被保人為同一人
      if (this.state.isSelf) {
        creditPayerId = policyholders[0].ID;
        bankPayerId = policyholders[0].ID;
      }

      // 預設要保人為付款人
      if (val === PaymentMethod.CreditCard) {
        creditPayerId = policyholders[0].ID;
        bankPayerId = policyholders[0].ID;
      }

      // 僅被保人，設定付款人為被保人
      if (val === PaymentMethod.CreditCard && this.state.onlyInsured) {
        creditPayerType = InsuredRoleType.Insured;
        creditPayerId = insureds[0].ID;
        bankPayerId = insureds[0].ID;
        bankPayerType = InsuredRoleType.Insured;
        activeInsRoleType = InsuredRoleType.Insured;
      }
    } else {
      const { tempFillFormValue } = this.props.tempFill;
      if (!tempFillFormValue) return;

      if (tempFillFormValue.INSURED_NATIONALITY_TYPE === NationalType.Legal) {
        this.setState({ activePaymentMethod: val, activeInsRoleType: activeInsRoleType });
        return;
      }

      // 要、被保人為同一人
      if (this.state.isSelf) {
        creditPayerId = tempFillFormValue.POLICYHOLDER_MEMBER_ID;
        bankPayerId = tempFillFormValue.POLICYHOLDER_MEMBER_ID;
      }

      // 預設要保人為付款人
      if (val === PaymentMethod.CreditCard) {
        creditPayerId = tempFillFormValue.POLICYHOLDER_MEMBER_ID;
        bankPayerId = tempFillFormValue.POLICYHOLDER_MEMBER_ID;
      }

      // 僅被保人，設定付款人為被保人
      if (val === PaymentMethod.CreditCard && this.state.onlyInsured) {
        creditPayerType = InsuredRoleType.Insured;
        creditPayerId = tempFillFormValue.INSURED_MEMBER_ID;
        bankPayerId = tempFillFormValue.INSURED_MEMBER_ID;
        bankPayerType = InsuredRoleType.Insured;
        activeInsRoleType = InsuredRoleType.Insured;
      }
    }

    if (val === PaymentMethod.BarCode) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '行動條碼繳費說明',
        html: commonService.getCodeMsg(this.props.UICodes, CodeId.U040)
      });
    }

    const setFieldValue = this.formikRef.current.setFieldValue;

    setFieldValue('CREDIT_PAYER_TYPE', creditPayerType);
    setFieldValue('BANK_PAYER_TYPE', bankPayerType);
    setFieldValue('BANK_PAYER_ID', bankPayerId);
    setFieldValue('CREDIT_PAYER_ID', creditPayerId);
    setFieldValue('PAYMENT_METHOD', val);

    this.setState({ activePaymentMethod: val, activeInsRoleType: activeInsRoleType });
  }

  /**
 * @description 取得投保金額
*/
  handleGetFee = () => {
    if (this.props.boPayby.APPLY_NO) {
      return `NT$ ${commonService.thousandFormat(this.props.boPayby.POLICY_FEE ? `${this.props.boPayby.POLICY_FEE}` : '')}`;
    }

    return `NT$ ${commonService.thousandFormat(`${commonService.getVehiclePrenium(this.props.tempSelect.tempSelectState?.evalCarRes.SUMPREMIUM[1].SUMPREMIUM, this.props.tempSelect.tempSelectState?.evalCarRes.SUMPREMIUM[1].SUMPREMIUMCI)}`)}`;
  }

  render () {
    const validationSchema = Yup.object().shape({
      PAYMENT_METHOD: Yup.string().required('此為必填欄位'),
      // CREDIT_ACCOUNT_HOLDER_NAME: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
      //   if (this.props.boPayby.APPLY_NO) {
      //     const insureds =
      //       _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

      //     return method === PaymentMethod.CreditCard && insureds[0].ID_TYPE === NationalType.Legal
      //       ? schema.required('此為必填欄位。')
      //       : schema;
      //   }

      //   return method === PaymentMethod.CreditCard && tempFillFormValue?.INSURED_NATIONALITY_TYPE === NationalType.Legal
      //     ? schema.required('此為必填欄位。')
      //     : schema;
      // }),
      // CREDIT_ACCOUNT_HOLDER_ID: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
      //   if (this.props.boPayby.APPLY_NO) {
      //     const insureds =
      //       _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

      //     return method === PaymentMethod.CreditCard && insureds[0].ID_TYPE === NationalType.Legal
      //       ? schema.required('此為必填欄位。').length(10, '帳號長度為 10 字元').matches(/^[A-Z]\d{9}$/, '帳號格式不符')
      //       : schema;
      //   }

      //   return method === PaymentMethod.CreditCard && tempFillFormValue?.INSURED_NATIONALITY_TYPE === NationalType.Legal
      //     ? schema.required('此為必填欄位。').length(10, '帳號長度為 10 字元').matches(/^[A-Z]\d{9}$/, '帳號格式不符')
      //     : schema;
      // }),
      // CREDIT_ACCOUNT_HOLDER_RELATION: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
      //   if (this.props.boPayby.APPLY_NO) {
      //     const insureds =
      //       _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

      //     return method === PaymentMethod.CreditCard && insureds[0].ID_TYPE === NationalType.Legal
      //       ? schema.required('此為必填欄位。')
      //       : schema;
      //   }

      //   return method === PaymentMethod.CreditCard && tempFillFormValue?.INSURED_NATIONALITY_TYPE === NationalType.Legal
      //     ? schema.required('此為必填欄位。')
      //     : schema;
      // }),
      CREDIT_PAYER_TYPE: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
        // if (this.props.boPayby.APPLY_NO) {
        //   const insureds =
        //     _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

        //   return method === PaymentMethod.CreditCard && insureds[0].ID_TYPE !== NationalType.Legal
        //     ? schema.required('此為必填欄位。')
        //     : schema;
        // }

        return method === PaymentMethod.CreditCard
          ? schema.required('此為必填欄位。')
          : schema;
      }),
      CREDIT_PAYER_ID: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
        // if (this.props.boPayby.APPLY_NO) {
        //   const insureds =
        //     _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

        //   return method === PaymentMethod.CreditCard && insureds[0].ID_TYPE !== NationalType.Legal
        //     ? schema.required('此為必填欄位。')
        //     : schema;
        // }

        return method === PaymentMethod.CreditCard
          ? schema.required('此為必填欄位。')
          : schema;
      }),
      PAN1st: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
        return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。').length(4, '長度為 4 字元') : schema;
      }),
      PAN2nd: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
        return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。').length(4, '長度為 4 字元') : schema;
      }),
      PAN3rd: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
        return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。').length(4, '長度為 4 字元') : schema;
      }),
      PAN4th: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
        return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。').length(4, '長度為 4 字元') : schema;
      }),
      EXPIREDATE_MONTH: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
        return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。').length(2, '長度為 2 字元') : schema;
      }),
      EXPIREDATE_YEAR: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
        return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。').length(2, '長度為 2 字元') : schema;
      }),
      CARD_VERIFY_CODE: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
        return method === PaymentMethod.CreditCard ? schema.required('此為必填欄位。').length(3, '長度為 3 字元') : schema;
      }),
      BANK_CODE: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
        return method === PaymentMethod.BankAccount ? schema.required('此為必填欄位。') : schema;
      }),
      BANK_ACCOUNT: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
        return method === PaymentMethod.BankAccount ? schema.required('此為必填欄位。').min(11, '長度不可少於 11 字元').max(14, '長度不可超過 14 字元') : schema;
      }),
      // BANK_ACCOUNT_HOLDER_RELATION: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
      //   if (this.props.boPayby.APPLY_NO) {
      //     const insureds =
      //       _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

      //     return method === PaymentMethod.BankAccount && insureds[0].ID_TYPE === NationalType.Legal
      //       ? schema.required('此為必填欄位。')
      //       : schema;
      //   }

      //   return method === PaymentMethod.BankAccount && tempFillFormValue?.INSURED_NATIONALITY_TYPE === NationalType.Legal
      //     ? schema.required('此為必填欄位。')
      //     : schema;
      // }),
      // BANK_ACCOUNT_HOLDER_ID: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
      //   if (this.props.boPayby.APPLY_NO) {
      //     const insureds =
      //       _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

      //     return method === PaymentMethod.BankAccount && insureds[0].ID_TYPE === NationalType.Legal
      //       ? schema.required('此為必填欄位。').length(10, '帳號長度為 10 字元').matches(/^[A-Z]\d{9}$/, '帳號格式不符')
      //       : schema;
      //   }

      //   return method === PaymentMethod.BankAccount && tempFillFormValue?.INSURED_NATIONALITY_TYPE === NationalType.Legal
      //     ? schema.required('此為必填欄位。').length(10, '帳號長度為 10 字元').matches(/^[A-Z]\d{9}$/, '帳號格式不符')
      //     : schema;
      // }),
      // BANK_ACCOUNT_HOLDER_NAME: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
      //   if (this.props.boPayby.APPLY_NO) {
      //     const insureds =
      //       _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

      //     return method === PaymentMethod.BankAccount && insureds[0].ID_TYPE === NationalType.Legal
      //       ? schema.required('此為必填欄位。')
      //       : schema;
      //   }

      //   return method === PaymentMethod.BankAccount && tempFillFormValue?.INSURED_NATIONALITY_TYPE === NationalType.Legal
      //     ? schema.required('此為必填欄位。')
      //     : schema;
      // }),
      BANK_PAYER_ID: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
        // if (this.props.boPayby.APPLY_NO) {
        //   const insureds =
        //     _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

        //   return method === PaymentMethod.BankAccount && insureds[0].ID_TYPE !== NationalType.Legal
        //     ? schema.required('此為必填欄位。')
        //     : schema;
        // }

        return method === PaymentMethod.BankAccount
          ? schema.required('此為必填欄位。')
          : schema;
      }),
      BANK_PAYER_TYPE: Yup.string().when('PAYMENT_METHOD', (method: any, schema: any) => {
        // if (this.props.boPayby.APPLY_NO) {
        //   const insureds =
        //     _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

        //   return method === PaymentMethod.BankAccount && insureds[0].ID_TYPE !== NationalType.Legal
        //     ? schema.required('此為必填欄位。')
        //     : schema;
        // }

        return method === PaymentMethod.BankAccount
          ? schema.required('此為必填欄位。')
          : schema;
      })
    });

    // #region 產生付款方式區塊

    let paymentMethod: any;
    if (Object.keys(this.state.paymentMethod.PAYMENT_INFO.PAYMENT_OPTION[0]).length > 0) {
      const paymentOpt = { ...this.state.paymentMethod.PAYMENT_INFO.PAYMENT_OPTION[0] };

      const optkeys = Object.keys(paymentOpt);

      paymentMethod = _.map(optkeys, (optKey: string, index: number) => {
        if (!this.state.showCreditCard && optKey === PaymentMethod.CreditCard) return;
        if (!this.state.showBarCode && optKey === PaymentMethod.BarCode) return;

        return (
          <div className="element__radio-group" key={index}>
            <label htmlFor={`credit-card-radio${index}`}>
              <div className="element__radio">
                <Field
                  type="radio"
                  name="PAYMENT_METHOD"
                  id={`credit-card-radio${index}`}
                  value={optKey}
                  onClick={(e: React.ChangeEvent<HTMLInputElement>) => this.handlePaymentMethodClick(e.currentTarget.value)}
                />
                <div className="element__radio-btn" />
              </div>
              <span>{paymentOpt[optKey]}</span>
            </label>
          </div>
        );
      });
    }

    // #endregion

    // #region 產生繳費提示訊息區塊、銀行下拉選單值、帳戶持有人與要保人關係下拉選單值

    let paymentInfo: JSX.Element;
    let bankOpts: JSX.Element[];
    if (this.state.paymentMethod) {
      let applyType;
      let applyCantName;
      if (this.props.boPayby.APPLY_NO) {
        const insureds =
          _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

        applyType = this.props.boPayby.BC_TYPE;
        applyCantName = insureds[0].NAME;
      }

      if (this.props.tempFill && this.props.tempFill.tempFillState && this.props.tempFill.tempFillFormValue) {
        applyType = this.props.tempFill.tempFillState.applyType;
        applyCantName = this.props.tempFill.tempFillFormValue.POLICYHOLDER_NAME;
      }

      let payment: PaymentContent = { ...this.state.paymentMethod.PAYMENT_INFO.COMMON_MSG.BANKACCOUNT };

      if (this.state.activePaymentMethod === PaymentMethod.CreditCard) {
        payment = { ...this.state.paymentMethod.PAYMENT_INFO.COMMON_MSG.CREDITCARD };
      }

      let paymentInfoStr: string = payment.NOTICE_B;
      if (applyType === ApplyType.WebInsured) {
        paymentInfoStr = payment.NOTICE_C;
      }

      // 建立銀行的下拉選單
      bankOpts = _.map(payment.BANK, (bank: BankContent, index: number) => {
        return <option value={bank.ID} key={index}>{`${bank.ID} ${bank.NAME}`}</option>;
      });

      paymentInfo = (
        <div className="insure-process-payment__part">
          <span className="insure-process-payment__part-title">{`親愛的${applyCantName}您好，`}</span>
          <p>{paymentInfoStr}</p>
          {
            this.state.activePaymentMethod === PaymentMethod.CreditCard
              ? <span className="element__link" onClick={() => handleShowAvailableBank(payment)}>目前可配合之發卡銀行</span>
              : null
          }
        </div>
      );
    }

    /**
      * @description 顯示可用銀行
     */
    const handleShowAvailableBank = (payment: PaymentContent) => {
      const msg = _.reduce(_.map(payment.BANK, (content: BankContent) => content.NAME), (res: string, curr: string) => {
        return `${res}、${curr}`;
      });

      sweetAlertService.modal({
        title: '可配合之發卡銀行',
        html: `<div class="cooperate-bank-modal__content">${msg}</div>`
      });
    };

    // #endregion

    // #region 產生線上繳費權益告知聲明事項區塊
    let paymentClaim: JSX.Element;
    if (this.state.paymentMethod) {
      paymentClaim = (
        <>
          <span className="insure-process-payment__part-title">{this.state.paymentMethod.PAYMENT_INFO.COMMON_MSG.CLAIMS.HEAD}</span>
          <p>{commonService.htmlParser(this.state.paymentMethod.PAYMENT_INFO.COMMON_MSG.CLAIMS.BODY)}</p>
          <br />
          <div className="element__checkbox-group">
            <label htmlFor="receive-information-checkbox">
              <div className="element__checkbox">
                <Field
                  type="checkbox"
                  name="RECEIVE_INFO"
                  id="receive-information-checkbox"
                  onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                    this.setState({ agreeContract: e.currentTarget.checked });
                  }}
                />
                <div className="element__checkbox-btn" />
              </div>
              <span>{this.state.paymentMethod.PAYMENT_INFO.COMMON_MSG.CLAIMS.ANSWER.BODY}</span>
            </label>
          </div>
        </>
      );
    }
    // #endregion

    // #region 產生被保人/要保人選項區塊

    let insRole: JSX.Element[];
    if (this.state.insRoleTypeSysOpts && this.state.insRoleTypeSysOpts.length > 0) {
      insRole = _.map(this.state.insRoleTypeSysOpts, (sysOpt: SysOption, index: number) => {
        return (
          <div
            className="element__radio-group" key={index}
          >
            <label htmlFor={`insRole-radio${index}`}>
              <div className="element__radio">
                <Field
                  type="radio"
                  disabled={this.state.isSelf || (this.state.activePaymentMethod === PaymentMethod.CreditCard && (this.state.onlyApplicant || this.state.onlyInsured))}
                  name={this.state.activePaymentMethod === PaymentMethod.CreditCard ? 'CREDIT_PAYER_TYPE' : 'BANK_PAYER_TYPE'}
                  id={`insRole-radio${index}`}
                  value={sysOpt.PARAM_VALUE}
                  onClick={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const activeInsRoleType = this.state.activeInsRoleType;
                    if (activeInsRoleType !== e.currentTarget.value) {
                      const fieldName = this.state.activePaymentMethod === PaymentMethod.CreditCard ? 'CREDIT_PAYER_ID' : 'BANK_PAYER_ID';
                      this.formikRef.current.setFieldValue(fieldName, '');
                    }
                    this.setState({ activeInsRoleType: e.currentTarget.value });
                  }}
                />
                <div className="element__radio-btn" />
              </div>
              <span className="span-nowrap">{sysOpt.PARAM_TEXT}</span>
            </label>
          </div>
        );
      });
    }

    // #endregion

    // #region 依付款人身分顯示姓名下拉選單

    let roleTypeOtps: any = null;
    if (this.state.activeInsRoleType) {
      switch (this.state.activeInsRoleType) {
        case InsuredRoleType.Application: {
          if (this.props.boPayby.APPLY_NO) {
            roleTypeOtps = _.map(this.props.boPayby.PAYER_LIST, (payer: PayerContent, index: number) => {
              if (payer.LTYPE === RuleCheckInsuredType.Insured || (this.state.activePaymentMethod === PaymentMethod.CreditCard &&
                payer.ID_TYPE === NationalType.Legal)
              ) return;

              return <option key={index} value={payer.ID}>{payer.NAME}</option>;
            });
          } else {
            roleTypeOtps = <option value={this.props.tempFill.tempFillFormValue?.POLICYHOLDER_MEMBER_ID}>{this.props.tempFill.tempFillFormValue?.POLICYHOLDER_NAME}</option>;

            if (this.state.activePaymentMethod === PaymentMethod.CreditCard &&
              this.props.tempFill.tempFillFormValue?.POLICYHOLDER_NATIONALITY_TYPE === NationalType.Legal) {
              roleTypeOtps = null;
            }
          }
          break;
        }
        case InsuredRoleType.Insured: {
          if (this.props.boPayby.APPLY_NO) {
            roleTypeOtps = _.map(this.props.boPayby.PAYER_LIST, (payer: PayerContent, index: number) => {
              if (payer.LTYPE === RuleCheckInsuredType.Applicant || (this.state.activePaymentMethod === PaymentMethod.CreditCard &&
                payer.ID_TYPE === NationalType.Legal)
              ) return;

              return <option key={index} value={payer.ID}>{payer.NAME}</option>;
            });
          } else {
            roleTypeOtps = <option value={this.props.tempFill.tempFillFormValue?.INSURED_MEMBER_ID}>{this.props.tempFill.tempFillFormValue?.INSURED_NAME}</option>;
            if (this.state.activePaymentMethod === PaymentMethod.CreditCard &&
              this.props.tempFill.tempFillFormValue?.INSURED_NATIONALITY_TYPE === NationalType.Legal) {
              roleTypeOtps = null;
            }
          }
          break;
        }
      }
    }

    // #endregion

    /**
     * @description 判斷被保人是否為法人
     */
    const handleValidateBoPayLegalType = () => {
      const insureds =
        _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

      return insureds[0].ID_TYPE === NationalType.Legal;
    };

    /**
     * @description 取得補繳費信用卡樣式
     */
    const handleGetBoPayCreditClassType = () => {
      const isLegal = handleValidateBoPayLegalType();

      return isLegal ? NationalType.Legal : NationalType.National;
    };

    /**
     * @description 建立 BarCode 區塊
     */
    const handleCreateBarCode = () => {
      let policyholderName;
      let dueDate;
      let insuredName;
      let activePlanName;
      let fee;
      if (this.props.boPayby.APPLY_NO) {
        const policyholders =
          _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Applicant);

        const insureds =
          _.filter(this.props.boPayby.PAYER_LIST, (payer: PayerContent) => payer.LTYPE === RuleCheckInsuredType.Insured);

        policyholderName = policyholders[0].NAME;
        insuredName = insureds[0].NAME;
        activePlanName = this.props.boPayby.PROD_NAME;
        fee = this.props.boPayby.POLICY_FEE;

        // 是否包含強制險項目
        const hasCompulsory = moment(this.props.boPayby.CO_START_DATE).isValid();

        // 是否包含任意險項目
        const hasArbitrary = moment(this.props.boPayby.VO_START_DATE).isValid();
        // 取得使用日期
        const useDate = this.handleGetInsuredDate(hasCompulsory, hasArbitrary, this.props.boPayby.CO_START_DATE, this.props.boPayby.VO_START_DATE);

        dueDate = moment(useDate).isValid()
          ? moment(useDate).add(-7, 'd').format('YYYY年MM月DD日 12:00')
          : '';
      }

      const { tempFillFormValue } = this.props.tempFill;
      const { tempSelectState, tempSelectFormValue } = this.props.tempSelect;
      if (tempFillFormValue && tempSelectState && tempSelectFormValue) {
        policyholderName = tempFillFormValue.POLICYHOLDER_NAME;
        insuredName = tempFillFormValue.INSURED_NAME;
        activePlanName = tempSelectState.activePlanName;
        fee = commonService.getVehiclePrenium(tempSelectState.evalCarRes.SUMPREMIUM[1].SUMPREMIUM, tempSelectState.evalCarRes.SUMPREMIUM[1].SUMPREMIUMCI);

        // 取得有投保項目
        const insuredPolicys = this.handleFetchInsuredPolicys(tempSelectFormValue.POLICY_ITEM);
        // 是否包含強制險項目
        const hasCompulsory = this.handleValidateHasType(insuredPolicys, VehicleItemType.CV_TYPE_CI);

        // 是否包含任意險項目
        const hasArbitrary = this.handleValidateHasType(insuredPolicys, VehicleItemType.CV_TYPE_VI);
        // 取得使用日期
        const useDate = this.handleGetInsuredDate(hasCompulsory, hasArbitrary, tempSelectFormValue.COMPULSORY_INS_EFFECTIVE_DATE, tempSelectFormValue.ARBITRARY_INS_EFFECTIVE_DATE);

        dueDate = moment(useDate).isValid()
          ? moment(useDate).add(-7, 'd').format('YYYY年MM月DD日 12:00')
          : '';
      }

      return (
        <div className="insure-process-payment__list">
          <div className="element__list">
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">要保人姓名</div>
                <div className="element__list-group-content">{policyholderName}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">繳費期限</div>
                <div className="element__list-group-content">{dueDate}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">被保險人姓名</div>
                <div className="element__list-group-content">{insuredName}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">投保方案</div>
                <div className="element__list-group-content">{activePlanName}</div>
              </div>
            </div>
            <div className="element__list-col">
              <div className="element__list-group">
                <div className="element__list-group-title">保費金額</div>
                <div className="element__list-group-content">{`NT$ ${commonService.thousandFormat(`${fee}`)} 元`}</div>
              </div>
            </div>
          </div>
        </div>
      );
    };

    return (
      <div className="insure-process-payment">
        <Formik
          validationSchema={validationSchema}
          initialValues={formInitialValues}
          onSubmit={this.handleFormSubmit}
          enableReinitialize
          innerRef={this.formikRef}
        >
          {({ values, errors, touched, handleChange, setFieldTouched, setFieldValue }) => (
            <Form>
              <div className="insure-process-payment__title">選擇支付方式</div>
              <div className="insure-process-payment__content">
                <div className="insure-process-payment__row">
                  {paymentMethod}
                </div>
                {
                  values.PAYMENT_METHOD === PaymentMethod.BarCode && handleCreateBarCode()
                }
                {
                  values.PAYMENT_METHOD !== PaymentMethod.BarCode && (
                    <>
                      {paymentInfo}
                      <div className="insure-process-payment__part">
                        {paymentClaim}
                      </div>
                    </>
                  )
                }
                <div className={`insure-process-payment__payment-form insure-process-payment__payment-form--${this.props.tempFill.tempFillFormValue ? this.props.tempFill.tempFillFormValue.INSURED_NATIONALITY_TYPE : handleGetBoPayCreditClassType()}`}>
                  {/* 信用卡扣款 */}
                  {values.PAYMENT_METHOD === PaymentMethod.CreditCard && this.state.agreeContract && (
                    <div className="insure-process-payment__credit-cards">
                      <div className="insure-process-payment__credit-card">
                        <div className="insure-process-payment__credit-card-container">
                          <div className="insure-process-payment__row">
                            <span>金額</span>
                            <span>{this.handleGetFee()}</span>
                          </div>
                          <div className="insure-process-payment__row">
                            <div className={'element__form-group' + (
                              (errors.PAN1st && touched.PAN1st) ||
                                (errors.PAN2nd && touched.PAN2nd) ||
                                (errors.PAN3rd && touched.PAN3rd) ||
                                (errors.PAN4th && touched.PAN4th) ? ' element__form-group--invalid' : ''
                            )}
                            >
                              <div className="element__form-group-title">信用卡卡號</div>
                              <div className="element__form-group-content">
                                <Field
                                  component={InputWithRegex}
                                  name="PAN1st"
                                  id="PAN1st"
                                  className="element__input"
                                  maxLength="4"
                                  style={{ width: '25%' }}
                                  onBlur={() => {
                                    setFieldTouched('PAN1st', true);
                                  }}
                                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    handleChange(e);
                                    commonService.setInputAutoFocus('PAN1st', 'PAN2nd');
                                  }}
                                />
                                <Field
                                  component={InputWithRegex}
                                  name="PAN2nd"
                                  id="PAN2nd"
                                  className="element__input"
                                  maxLength="4"
                                  style={{ width: '25%' }}
                                  onBlur={() => {
                                    setFieldTouched('PAN2nd', true);
                                  }}
                                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    handleChange(e);
                                    commonService.setInputAutoFocus('PAN2nd', 'PAN3rd');
                                  }}
                                />
                                <Field
                                  component={InputWithRegex}
                                  name="PAN3rd"
                                  id="PAN3rd"
                                  className="element__input"
                                  maxLength="4"
                                  style={{ width: '25%' }}
                                  onBlur={() => {
                                    setFieldTouched('PAN3rd', true);
                                  }}
                                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    handleChange(e);
                                    commonService.setInputAutoFocus('PAN3rd', 'PAN4th');
                                  }}
                                />
                                <Field
                                  component={InputWithRegex}
                                  name="PAN4th"
                                  id="PAN4th"
                                  className="element__input"
                                  maxLength="4"
                                  style={{ width: '25%' }}
                                  onBlur={() => {
                                    setFieldTouched('PAN4th', true);
                                  }}
                                />
                              </div>
                              <div className="element__error-message">
                                {
                                  errors.PAN1st && touched.PAN1st ? <ErrorMessage name="PAN1st" />
                                    : errors.PAN2nd && touched.PAN2nd ? <ErrorMessage name="PAN2nd" />
                                      : errors.PAN3rd && touched.PAN3rd ? <ErrorMessage name="PAN3rd" />
                                        : errors.PAN4th && touched.PAN4th ? <ErrorMessage name="PAN4th" /> : ''
                                }
                              </div>
                            </div>
                          </div>
                          <div className="insure-process-payment__row">
                            <div className={'element__form-group' + (
                              (errors.EXPIREDATE_MONTH && touched.EXPIREDATE_MONTH) ||
                                (errors.EXPIREDATE_YEAR && touched.EXPIREDATE_YEAR) ? ' element__form-group--invalid' : ''
                            )}
                            >
                              <div className="element__form-group-title">信用卡到期(月/年)</div>
                              <div className="element__form-group-content">
                                <Field
                                  component={InputWithRegex}
                                  id="expire-date-month-input"
                                  name="EXPIREDATE_MONTH"
                                  className="element__input"
                                  maxLength="2"
                                  onBlur={() => {
                                    setFieldTouched('EXPIREDATE_MONTH', true);
                                  }}
                                  validate={(val: any) => {
                                    const reg = /((0[1-9]{1})|(1[0-2]{1}))/;
                                    if (val && !reg.test(val)) return '有效月份需為 01-12';

                                    return '';
                                  }}
                                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    handleChange(e);
                                    commonService.setInputAutoFocus('expire-date-month-input', 'expire-date-year-input');
                                  }}
                                />
                                <span>/</span>
                                <Field
                                  component={InputWithRegex}
                                  id="expire-date-year-input"
                                  name="EXPIREDATE_YEAR"
                                  className="element__input"
                                  maxLength="2"
                                  onBlur={() => {
                                    setFieldTouched('EXPIREDATE_YEAR', true);
                                  }}
                                  validate={(val: any) => {
                                    const nowYear = moment().format('YYYY');
                                    const validYear = +nowYear.substr(2, 2);
                                    if (val && +val < validYear) return `有效年份需大於 (等於) ${nowYear}`;

                                    return '';
                                  }}
                                />
                              </div>
                              <div className="element__error-message">
                                {
                                  errors.EXPIREDATE_MONTH && touched.EXPIREDATE_MONTH
                                    ? <ErrorMessage name="EXPIREDATE_MONTH" />
                                    : errors.EXPIREDATE_YEAR && touched.EXPIREDATE_YEAR
                                      ? <ErrorMessage name="EXPIREDATE_YEAR" /> : ''
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="insure-process-payment__credit-card">
                        <div className="insure-process-payment__credit-card-remind">{commonService.getCodeMsg(this.props.UICodes, CodeId.U032)}</div>
                        <div className="insure-process-payment__credit-card-container">
                          <div className="insure-process-payment__row">
                            <div className={'element__form-group' + ((errors.CREDIT_PAYER_TYPE && touched.CREDIT_PAYER_TYPE) ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-content">
                                {insRole}
                              </div>
                              <div className="element__error-message">
                                <ErrorMessage name="CREDIT_PAYER_TYPE" />
                              </div>
                            </div>
                          </div>
                          <div className="insure-process-payment__row">
                            <div className={'element__form-group' + ((errors.CREDIT_PAYER_ID && touched.CREDIT_PAYER_ID) ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">扣款人姓名</div>
                              <Field as="select" disabled={this.state.isSelf || (this.state.activePaymentMethod === PaymentMethod.CreditCard && (this.state.onlyApplicant || this.state.onlyInsured))} name="CREDIT_PAYER_ID" className="element__select">
                                <option value="">請選擇</option>
                                {roleTypeOtps}
                              </Field>
                              <div className="element__error-message">
                                <ErrorMessage name="CREDIT_PAYER_ID" />
                              </div>
                            </div>
                            <div className={'element__form-group' + ((errors.CARD_VERIFY_CODE && touched.CARD_VERIFY_CODE) ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">三碼檢查碼</div>
                              <Field
                                component={InputWithRegex}
                                id="card-verify-code-input"
                                autoComplete="off"
                                name="CARD_VERIFY_CODE"
                                className="element__input" maxLength={3}
                                onBlur={() => {
                                  setFieldTouched('CARD_VERIFY_CODE', true);
                                }}
                              />
                              <div className="element__error-message">
                                <ErrorMessage name="CARD_VERIFY_CODE" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* 活期帳戶扣款 */}
                  {values.PAYMENT_METHOD === PaymentMethod.BankAccount && this.state.agreeContract && (
                    <div className="insure-process-payment__current-account">
                      <div className="insure-process-payment__current-account-container">
                        <div className="insure-process-payment__row">
                          <span>金額</span>
                          <span>{this.handleGetFee()}</span>
                        </div>
                        <div className="insure-process-payment__row">
                          <div className={'element__form-group' + (errors.BANK_CODE && touched.BANK_CODE ? ' element__form-group--invalid' : '')}>
                            <div className="element__form-group-content">
                              <span>銀行</span>
                              <Field as="select" name="BANK_CODE" className="element__select">
                                <option value="">請選擇</option>
                                {bankOpts}
                              </Field>
                            </div>
                            <ErrorMessage name="BANK_CODE" component="div" className="element__error-message" />
                          </div>
                        </div>
                        <div className="insure-process-payment__row">
                          <div className={'element__form-group' + (errors.BANK_ACCOUNT && touched.BANK_ACCOUNT ? ' element__form-group--invalid' : '')}>
                            <div className="element__form-group-content">
                              <span>帳號</span>
                              <Field
                                component={InputWithRegex}
                                id="bank-account-input"
                                autoComplete="off"
                                name="BANK_ACCOUNT"
                                className="element__input"
                                maxLength="14"
                                onBlur={() => {
                                  setFieldTouched('BANK_ACCOUNT', true);
                                }}
                              />
                            </div>
                            <div className="element__error-message">
                              <ErrorMessage name="BANK_ACCOUNT" />
                            </div>
                          </div>
                        </div>
                        <div className="insure-process-payment__row">
                          <div className={'element__form-group' + (errors.BANK_PAYER_TYPE && touched.BANK_PAYER_TYPE ? ' element__form-group--invalid' : '')}>
                            <div className="element__form-group-content">
                              {insRole}
                            </div>
                            <div className="element__error-message">
                              <ErrorMessage name="BANK_PAYER_TYPE" />
                            </div>
                          </div>
                        </div>
                        <div className="insure-process-payment__row">
                          <div className={'element__form-group' + (errors.BANK_PAYER_ID && touched.BANK_PAYER_ID ? ' element__form-group--invalid' : '')}>
                            <Field as="select" disabled={this.state.isSelf || (this.state.activePaymentMethod === PaymentMethod.CreditCard && (this.state.onlyApplicant || this.state.onlyInsured))} name="BANK_PAYER_ID" className="element__select">
                              <option value="">請選擇</option>
                              {roleTypeOtps}
                            </Field>
                            <div className="element__error-message">
                              <ErrorMessage name="BANK_PAYER_ID" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* 行動條碼繳費 */}
                  {values.PAYMENT_METHOD === PaymentMethod.BarCode && (
                    <>
                      <div className="insure-process-payment__part">
                        <span className="insure-process-payment__part-title">行動條碼支付方式及說明：</span>
                        {
                          _.map(this.state.barcodeNoticeCodes, (code: Code, index: number) => {
                            return <p className="barcode-info" key={index}>{commonService.htmlParser(code.CODE_VALUE)}</p>;
                          })
                        }
                      </div>
                      <div className="insure-process-payment__part">
                        <span className="insure-process-payment__part-title">注意事項</span>
                        <p>
                          {
                            _.map(this.state.barcodeNoteCodes, (code: Code, index: number) => {
                              return React.cloneElement(
                                <>
                                  {`${code.CODE_VALUE}`}<br />
                                </>
                                , { key: index }
                              );
                            })
                          }
                        </p>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="insure-process-payment__controls">
                <button
                  type="button"
                  className="element__button element__button--red-border"
                  onClick={() => {
                    if (!this.props.boPayby.APPLY_NO) {
                      this.props.onGoBack();
                    }
                  }}
                >
                  返回上一頁
                </button>
                <button id="btn_pay" type="submit" className="element__button element__button--red" disabled={!this.state.agreeContract && values.PAYMENT_METHOD !== PaymentMethod.BarCode}>確認支付</button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default InsureProcessPayment;
